import React from "react";
import { Carousel } from "react-responsive-carousel";
import { useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // For carousel styling
import { FaPlane, FaRegClock, FaCreditCard } from "react-icons/fa";
import bali from "../assets/places/bali/bali.jpg";
import bali1 from "../assets/places/bali/bali1.jpg";
import bali2 from "../assets/places/bali/bali2.jpg";
import CustomizedForm from "../components/OrderPopup/Forms";
import { useSelector } from "react-redux";

const Flights = () => {
  const theme = useSelector((state) => state.theme.theme); // Assuming 'theme' holds 'dark' or 'light'
  const isDarkTheme = theme === "dark";
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const themeClasses = isDarkTheme
    ? "bg-black text-white"
    : "bg-white text-black";

  const cardClasses = isDarkTheme
    ? "bg-[#5b53fb] text-white"
    : "bg-[#dcdafc] text-gray-900";

  const heroOverlayClasses = isDarkTheme
    ? "bg-black bg-opacity-50"
    : "bg-white bg-opacity-70";

  const formSectionClasses = isDarkTheme
    ? "bg-black border-[#5b53fb]"
    : "bg-gray-50 border-[#5b53fb]";

  return (
    <div className={`${themeClasses} min-h-screen`}>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[60vh] flex items-center justify-center"
        style={{
          backgroundImage: `url(${bali1})`,
        }}
      >
        <div className={`p-8 rounded-md text-center ${heroOverlayClasses}`}>
          <h1 className="text-4xl font-bold text-[#5b53fb]">Book Your Flight</h1>
          <p className="mt-2 text-lg font-light">
            Explore exciting destinations with great flight deals.
          </p>
        </div>
      </div>

      {/* Carousel Section */}
      <section className="py-8">
        <h2 className="text-2xl font-bold text-[#5b53fb] text-center mb-6">
          Flight Offers & Deals
        </h2>
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={3000}
          showStatus={false}
        >
          <div
            className={`flex justify-center items-center p-4 ${cardClasses}`}
          >
            <FaPlane size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Cheap Flights</h3>
              <p>Save up to 50% on selected international flights.</p>
            </div>
          </div>
          <div
            className={`flex justify-center items-center p-4 ${cardClasses}`}
          >
            <FaRegClock size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Flexible Dates</h3>
              <p>
                Change your flight dates for free within 24 hours of booking.
              </p>
            </div>
          </div>
          <div
            className={`flex justify-center items-center p-4 ${cardClasses}`}
          >
            <FaCreditCard size={50} className="mr-4" />
            <div>
              <h3 className="text-lg font-semibold">Easy Payments</h3>
              <p>Pay in installments for all your flight bookings.</p>
            </div>
          </div>
        </Carousel>
      </section>

      {/* Flight Booking Form */}
      <section
        className={`max-w-7xl mx-auto border rounded-lg shadow-lg p-8 ${formSectionClasses}`}
      >
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-[#5b53fb]">
            Flight Booking Form
          </h2>
          <p>Fill in the details below to book your flight.</p>
        </div>
        <CustomizedForm name="Book your flight" />
      </section>

      {/* Additional Info Section */}
      <section className="py-10">
        <h2 className="text-2xl font-bold text-[#5b53fb] text-center mb-6">
          Why Choose Us for Your Flight Booking?
        </h2>
        <div className="flex flex-wrap justify-center gap-6">
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">24/7 Support</h3>
            <p>Our team is available around the clock to assist you.</p>
          </div>
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">Best Price Guarantee</h3>
            <p>We ensure you get the best deals for your flights.</p>
          </div>
          <div className={`p-4 rounded-md w-80 text-center ${cardClasses}`}>
            <h3 className="text-lg font-semibold">Fast Booking</h3>
            <p>
              Book your flight in just a few clicks and get instant
              confirmation.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Flights;
